export const PRERENDER_EVENT = 'prerender-ready'

export function isPrerenderBuild() {
  return process.env.VUE_APP_PRERENDER === 'true'
}

export function emitPrerenderReady() {
  if (!isPrerenderBuild() || typeof document === 'undefined') return
  document.dispatchEvent(new Event(PRERENDER_EVENT))
}
